'use strict';

var $ = require('jquery');
//var Animation = require('../lib/Animation.js');
//var AnimationEasing = require('../lib/AnimationEasing.js');
//var Range = require('../lib/Range.js');

var StateManager = require('../lib/StateManager.js');
var StateHolder = StateManager.StateHolder;

var Analytics = require('@plaudit/analytics').Analytics;
var myAnalytics = Analytics.getInstance();

function removeFromArray(a, v) {
	if (a === undefined)
		return;
	var index = a.indexOf(v);
	if (index != -1) {
		a.splice(index, 1);
	}
}

function ItemFilterManager($filtersArea, $filterOptions, $products, config) {

	// Gathers data about options
	var optionsByNameValue = {};
	for (var i=0; i < $filterOptions.length; i++) {
		var $filterOption = $filterOptions.eq(i);
		var data = createOptionData($filterOption);
		$filterOption.data('optiondata', data);

		optionsByNameValue[data.filter + ':' + data.value] = $filterOption;
	}
	function createOptionData($filterOption) {
		var value = $filterOption.val();

		var id = $filterOption.attr('id');
		var label = $('label[for='+id+']').text();

		return {
			filter: $filterOption.attr('name'),
			value: value,
			label: label
		};
	}
	function getOptionByNameValue(filter, value) {
		return optionsByNameValue[filter + ':' + value];
	}

	/**
	 * Returns filter and option value from given filter option jquery object
	 */
	function getOptionData($filterOption) {
		var data = $filterOption.data('optiondata');

		if (!data.value) {
			data.enabled = false;
		} else {
			data.enabled = false;
			if ($filterOption.prop('tagName') == 'SELECT') {
				data.enabled = true;
			} else if ($filterOption.prop('tagName') == 'INPUT') {
				data.enabled = $filterOption.get(0).checked;
				if (data.enabled === undefined)
					data.enabled = false;
			}
		}

		return data;
	}

	function setOptionValue($filterOption, values) {
		if ($filterOption.prop('tagName') == 'SELECT') {
			$filterOption.val(values);
		} else if ($filterOption.prop('tagName') == 'INPUT') {
			var enabled;
			if (values === undefined || values.length === 0) {
				enabled = false;
			} else {
				var value = $filterOption.val();
				enabled = values.indexOf(value) !== -1;
			}

			$filterOption.get(0).checked = enabled;
		}
	}


	function FiltersStateHolder() {
		StateHolder.call(this, 'f');
	}
	FiltersStateHolder.prototype = Object.create(StateHolder.prototype);

	// NOTE: We do not have code in place to generate a stateTitle for fitlers
	//  since we don't report these as a pageView anyways
	//FiltersStateHolder.prototype.getStateTitle = function() {}
	
	FiltersStateHolder.prototype.updateSelectedFilters = function(save, refresh) {
		if (save === undefined)
			save = true;
		if (refresh === undefined)
			refresh = true;

		this.state = {};

		for (var i=0; i < $filterOptions.length; i++) {
			var $this = $filterOptions.eq(i);
			var data = getOptionData($this);

			if (data.enabled) {
				if (this.state[data.filter] === undefined) {
					this.state[data.filter] = [];
				}
				this.state[data.filter].push(data.value);
			}
		}

		if (save) {
			StateManager.instance.save(refresh);
		}
	}
	FiltersStateHolder.prototype.loaded = function(prevState) {
		if (this.state === undefined)
			this.state = {};

		// Ensure filters match options
		for (var i=0; i < $filterOptions.length; i++) {
			var $this = $filterOptions.eq(i);
			var data = getOptionData($this);
			var dataFilterSelectedFilters = this.state[data.filter];
			setOptionValue($this, dataFilterSelectedFilters);
		}

		markMatchingProductsAndFilterOptions();
	}

	var filtersStateHolder = new FiltersStateHolder();

	// Configure change on a filter link to modify filters.
	$filterOptions.on('change', changeFilterSelection);
	function changeFilterSelection(e) {
		e.preventDefault();
		var toggledStatus = this.checked ? 'On' : 'Off'
		myAnalytics.trackEvent('Products', 'Toggle ' + toggledStatus, this.getAttribute('value'));
		filtersStateHolder.updateSelectedFilters();
	}

	function isMatch($product, overrideSelectedFilters) {
		var selectedFilters = filtersStateHolder.state;

		// Determine if product matches the filters
		var isAMatch = true;
		outer: for (var index=0; index < $filterOptions.length; index++) {
			var $filter = $filterOptions.eq(index);
			var data = getOptionData($filter);
			var filter = data.filter;

	        var filterValues;
	        if (overrideSelectedFilters !== undefined && overrideSelectedFilters.hasOwnProperty(filter)) {
	        	filterValues = overrideSelectedFilters[filter];
	        } else if (selectedFilters !== undefined && selectedFilters.hasOwnProperty(filter)) {
	        	filterValues = selectedFilters[filter];
	        } else {
	        	continue;
	        }

	        if (filterValues.length == 0)
	        	continue;

	        var productFilterValues = $product.attr('data-' + filter);
	        if (productFilterValues === undefined)
	        	break;
	        productFilterValues = productFilterValues.split(';');

	        var filterMatch = false;
	        for (var filterValuesIndex = 0; filterValuesIndex < filterValues.length; filterValuesIndex++) {
		        if (productFilterValues.indexOf(filterValues[filterValuesIndex]) !== -1) {
		        	filterMatch = true;
		        	break;
		        }
	        }
	        if (!filterMatch) {
	        	isAMatch = false;
	        	break outer;
	        }
	    }

		return isAMatch;
	}

	// ----------------------------------------------------------------------------
	// Mark products that are matches
	function markMatchingProductsAndFilterOptions() {
		var selectedFilters = filtersStateHolder.state;

		var matchedProducts = [];

		$products.each(function(index, element) {
			var $product = $(element);
			var isAMatch = isMatch($product);

		    if (isAMatch) {
		    	matchedProducts.push($product);

		    	if (config.matchClass)
		    		$product.addClass(config.matchClass);
		    	if (config.notMatchClass)
		    		$product.removeClass(config.notMatchClass);
		    } else {
		    	if (config.matchClass)
		    		$product.removeClass(config.matchClass);
		    	if (config.notMatchClass)
		    		$product.addClass(config.notMatchClass);
			}
		});

		// ----------------------------------------------------------------------------
		// Mark filter options that have no remaining remaining matches available
		$filterOptions.each(function(index, element) {
			var $this = $(element);

			var data = getOptionData($this);

			var $itemWrapper = $this.closest(config.filterItemSelector);

			var matchExists = false;
			if (selectedFilters[data.filter] !== undefined) {
				// There may not already be matches but we still must treat it as there
				// are since it is a filter that is on
				var selectedFiltersEntry = selectedFilters[data.filter];
				for (var selectedFilterDataIndex = 0; selectedFilterDataIndex < selectedFiltersEntry.length; selectedFilterDataIndex++) {
					var selectedFilterData = selectedFiltersEntry[selectedFilterDataIndex];
					if (selectedFilterData === data.value) {
						matchExists = true;
						break;
					}
				}
			}

			if (!matchExists) {
				// Look to see if any existing matched products match this filter
				/* When each option of a filter is an "AND" we can use this logic. But we are using "OR" so needed to change
				for (var matchedProductsIndex = 0; matchedProductsIndex < matchedProducts.length; matchedProductsIndex++) {
					var $product = matchedProducts[matchedProductsIndex];

					var productFilterValues = $product.attr('data-' + data.filter);
					if (productFilterValues === undefined)
						break;

					if (productFilterValues.indexOf(data.value) !== -1) {
						matchExists = true;
						break;
					}
				}
				*/

				for (var productI = 0; productI < $products.length; productI++) {
					var $product = $products.eq(productI);
					var override = {};
					override[data.filter] = [data.value];
					matchExists = isMatch($product, override);
					if (matchExists) {
						// No reason to keep looking
						break;
					}
				}
			}

			// Add class to filter option to denote if any remaining products match it
			var $input = $itemWrapper.find('input, select');
			if (matchExists) {
				// Enabled
				$itemWrapper.addClass(config.selectedClass);
				$itemWrapper.removeClass(config.noMatchesRemainClass);
				$input.removeAttr('disabled');
			} else {
				// Disabled
				$itemWrapper.removeClass(config.selectedClass);
				$itemWrapper.addClass(config.noMatchesRemainClass);
				$input.attr('disabled', true);
			}
		});

		// If they exist on the page, set add class to filter container
		// and change text of area that specifies what filters are on
		if ($filtersArea !== undefined) {
			var anyFiltersOn = false;
			$filterOptions.each(function(index, element) {
				var $this = $(this);
				var data = getOptionData($this);
				var filter = data.filter;

				var filterValues = selectedFilters[filter];
				if (filterValues === undefined)
					filterValues = [];

				if (filterValues.length > 0) {
					anyFiltersOn = true;
				}

				// Update visible value
				if (config.updateDisplayedFilterValue != null) {
					var labels = [];
					for (var selectedFilterDataIndex = 0; selectedFilterDataIndex < filterValues.length; selectedFilterDataIndex++) {
						var aValue = filterValues[selectedFilterDataIndex];
						var option = getOptionByNameValue(filter, aValue);
						if (option !== undefined) {
							var label = getOptionData(option).label;
							labels.push(label);
						}
					}

			        config.updateDisplayedFilterValue(filter, labels);
				}
			});

			if (anyFiltersOn) {
				$filtersArea.addClass(config.filtersOnClass);
			} else {
				$filtersArea.removeClass(config.filtersOnClass);
			}
		}


		if (config.onUpdate) {
			config.onUpdate(this);
		}
	}

	// Now that we are completely setup we can add the StateHandler to the StateManager, allowing it
	// to restore any current state and manage any future states.
	StateManager.instance.add(filtersStateHolder);

	// Ensure what should be visible is
	markMatchingProductsAndFilterOptions();
}

module.exports = ItemFilterManager;
